import dictionary from "assets/i18n.dictionary.json";

const supportLanguage = ["mn", "en", "ru", "jp", "ko", "cn"];

export const normalizeLanguageCode = (language) => {
  if (!language) return "";
  const normalized = String(language).toLowerCase().trim();
  if (normalized === "en") return "eng";
  return normalized;
};

export const normalizeAvailableLanguages = (info) => {
  if (!info) return [];

  const source = info.core || info;

  if (Array.isArray(source.contentLanguages)) {
    return source.contentLanguages.map(normalizeLanguageCode).filter(Boolean);
  }

  if (
    source.languages &&
    typeof source.languages === "object" &&
    !Array.isArray(source.languages)
  ) {
    return Object.keys(source.languages)
      .map(normalizeLanguageCode)
      .filter(Boolean);
  }

  if (Array.isArray(source.langs)) {
    return source.langs.map(normalizeLanguageCode).filter(Boolean);
  }

  if (Array.isArray(source.languageOptions)) {
    return source.languageOptions
      .map((x) => (typeof x === "string" ? x : x?.code || x?.lang))
      .map(normalizeLanguageCode)
      .filter(Boolean);
  }

  return [];
};

export const getLanguageLabel = (language) => {
  const normalized = normalizeLanguageCode(language);
  switch (normalized) {
    case "eng":
      return "English";
    case "ru":
      return "Русский";
    case "cn":
      return "中文";
    case "jp":
      return "日本語";
    case "ko":
      return "한국인";
    case "mn":
    default:
      return "Монгол";
  }
};

export const normalizeLanguageForContent = (language) => {
  if (!language) return "mn";
  const normalized = String(language).toLowerCase().trim();
  if (normalized === "eng") return "en";
  return normalized;
};

const normalizeLanguage = (language) => {
  if (!language) return "mn";
  if (language === "eng") return "en";
  if (supportLanguage.includes(language)) return language;
  return "mn";
};

export const languageBuild = (data, path, language = "mn", red = true) => {
  try {
    if (!data || !path) return null;
    const normalizedLanguage = normalizeLanguageForContent(language);
    const normalizedLanguageCode = normalizeLanguageCode(language);
    const hasValue = (value) =>
      value !== undefined &&
      value !== null &&
      value !== "undefined" &&
      value !== "";
    // Newer webinfo shape: { core, translation, ... }
    if (data.translation && hasValue(data.translation[path])) {
      return data.translation[path];
    }

    if (hasValue(data[path])) {
      return data[path];
    }

    if (data.core && hasValue(data.core[path])) {
      return data.core[path];
    }

    const languages = data.languages || {};
    const languagePriority = new Set(
      [normalizedLanguage, normalizedLanguageCode, language]
        .map((lang) => (typeof lang === "string" ? lang.trim() : ""))
        .filter(Boolean),
    );

    const languageQueue = [
      ...languagePriority,
      ...Object.keys(languages),
      ...supportLanguage,
    ];

    for (const lang of languageQueue) {
      if (languages[lang] && hasValue(languages[lang][path])) {
        if (red) return languages[lang][path];
        else return languages[lang][path];
      }
    }
    return null;
  } catch (error) {
    // console.log(error);
  }
};

export const getLocalTranslations = (keys, language = "mn") => {
  const lang = normalizeLanguage(language);
  const dict = dictionary[lang] || {};
  const result = {};

  if (Array.isArray(keys)) {
    keys.forEach((key) => {
      result[key] = dict[key] ?? key;
    });
    return result;
  }

  if (typeof keys === "string") {
    result[keys] = dict[keys] ?? keys;
    return result;
  }

  return result;
};

export const translateWord = async (keys, language = "mn") => {
  return getLocalTranslations(keys, language);
};
